import { useMutation } from "react-query";
import { CreateFeaturePayload } from "../../Interfaces/FeatureFlip";
import paths from "API/paths";
import axiosInstance from "Services/axiosConfig";
import { connected } from "process";

interface CreateFeaturePayloadP extends CreateFeaturePayload {
  projectId: string;
}

const createFeature = async (payload: CreateFeaturePayloadP) => {
  try {
    const url = paths.createFeature();
    const response = await axiosInstance.post(url, { input: payload });
    return response?.data?.data?.feature;
  } catch (error) {
    return Promise.reject(error);
  }
};
export const useCreateFeature = () => {
  return useMutation(createFeature);
};
